import {User} from "./user.model";

export class SignAsUserAccess extends User {
    public signAsUserId?: string;
    public invoqueurId?: string;
}
